<template>
  <el-form-item
    :label="$t('api.albumImage.label')"
    prop="album_image"
    >
    <div style="margin-bottom:8px" v-if="imgList.length > 0">
      <el-radio-group v-model="uploadMode">
        <el-radio-button :label="0">
          {{ $t('api.upload.file') }}
        </el-radio-button>
        <el-tooltip :content="$t('api.upload.sortTooltip')" placement="top">
          <el-radio-button :label="1">
            {{ $t('api.upload.sort') }}
          </el-radio-button>
        </el-tooltip>
      </el-radio-group>
    </div>
    <el-card v-if="uploadMode == 1">
      <draggable
        v-model="imgList"
        element="ul"
        class="el-upload-list el-upload-list--picture-card"
        @change="updateSort"
        >
        <li class="el-upload-list__item"
          v-for="img in imgList"
          :key="img.uid">
          <img
            class="dragable el-upload-list__item-thumbnail"
            :src="getImgURL(img.image_path)"
          />
        </li>
      </draggable>
      <div>
        <el-button
          type="primary"
          @click="saveSort"
          :disabled="!sortNeedSave"
          :loading="saveSortLoading">
          {{ $t('api.upload.saveSort') }}
        </el-button>
      </div>
    </el-card>
    <el-card
      v-else
      v-loading="uploading"
      >
      <el-upload
        class="album-uploader"
        action="./album_image"
        :before-remove="beforeRemove"
        :on-remove="handleRemove"
        :file-list="imgList"
        list-type="picture-card"
        :auto-upload="false"
        :on-change="onChange"
        drag
        multiple
        ref="upload"
        >
        <el-tooltip :content="$t('api.upload.dropOrClick')" placement="top">
          <i class="el-icon-upload"></i>
        </el-tooltip>
      </el-upload>
    </el-card>
    <viewer style="line-height:0px"
      @inited="inited"
      :images="imgList">
      <img v-for="obj in imgList" :src="obj.url" :key="obj.id" width="0" />
    </viewer>
    <el-button
      v-if="imgList.length > 0"
      type="primary"
      @click="view"
      >
      {{ $t('api.upload.view') }}
    </el-button>
    <el-button
      v-if="imgList.length > 0"
      type="danger"
      @click="clearAll"
      :loading="clearAllLoading"
      >
      {{ $t('api.upload.clearAll') }}
    </el-button>
  </el-form-item>
</template>

<script>

import _ from 'lodash'
import draggable from 'vuedraggable'
import { getImgURL } from '@/utils/path'

export default {
  components: {
    draggable
  },
  name: 'album-img',
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    uploadImage: {
      type: Function
    },
    updateImage: {
      type: Function
    },
    deleteImage: {
      type: Function
    },
    dataId: {
      type: String
    }
  },
  data () {
    return {
      id: this.dataId,
      uploadMode: 0,
      sortNeedSave: false,
      uploading: false,
      clearAllLoading: false,
      saveSortLoading: false,
      imgList: []
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    getImgURL,
    clearAll () {
      this.$confirm(this.$t('api.upload.clearAllConfirm'),
        this.$t('api.delConfirmTitle'), {
          confirmButtonText: this.$t('api.confirmBtn'),
          cancelButtonText: this.$t('api.cancelBtn'),
          confirmButtonClass: 'el-button--danger',
          type: 'warning'
        }).then(() => {
        this.clearAllLoading = true
        var data = { album_images: [] }
        this.updateImage(this.id, data).then(response => {
          this.clearImgList(this.formData.album_images)
          this.clearImgList(this.imgList)
          this.$message({
            message: this.$t('api.upload.clearAllSuccess'),
            type: 'success',
            duration: 2000
          })
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.clearAllLoading = false
        })
      }).catch(() => {
      })
    },
    updateSort () {
      this.sortNeedSave = true
    },
    getImgs () {
      var list = []
      this.imgList.forEach((ele, idx) => {
        var item = {
          id: ele.id,
          image_path: ele.image_path
        }
        list.push(item)
      })
      return list
    },
    saveSort () {
      this.saveSortLoading = true
      var data = { album_images: this.getImgs() }
      this.updateImage(this.id, data).then(response => {
        this.clearImgList(this.imgList)
        this.formData.album_images = response.data.album_images
        this.sortNeedSave = false
        this.$message({
          message: this.$t('api.upload.saveSortSuccess'),
          type: 'success',
          duration: 2000
        })
      }).catch(err => {
        console.log(err)
      }).then(() => {
        this.saveSortLoading = false
      })
    },
    beforeRemove (file, fileList) {
      if (!file.id) {
        return true
      }
      return this.$confirm(this.$t('api.delConfirmMsg', {
        id: file.id,
        name: file.name,
        idText: 'ID',
        dataText: this.$t('api.image')
      }), this.$t('api.delConfirmTitle'), {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      })
    },
    handleRemove (file, fileList) {
      if (!file.id) {
        return true
      }
      this.deleteImage(file.id).then(response => {
        this.removeImgList(this.formData.album_images, file)
        this.removeImgList(this.imgList, file)
        this.$message({
          message: this.$t('api.upload.deleteSuccess'),
          type: 'success',
          duration: 2000
        })
      }).catch(err => {
        console.log(err)
      })
      return true
    },
    inited (viewer) {
      this.$viewer = viewer
    },
    view () {
      this.$viewer.show()
    },
    onChange: _.debounce(function (file, fileList) {
      const filesRaw = fileList.map(f => f.raw)
      let data = new FormData()
      for (const file of filesRaw) {
        if (file && file.name) {
          data.append('files', file, file.name)
        }
      }
      this.uploading = true
      this.uploadImage(this.id, data, {}).then(response => {
        this.formData.album_images = response.data.album_images
        this.$message({
          message: this.$t('api.imgUploadSuccess'),
          type: 'success',
          duration: 2000
        })
      }).catch(err => {
        console.log(err)
      }).then(() => {
        this.uploading = false
      })
    }, 500),
    addImgList (imgs) {
      if (imgs) {
        for (var i = 0; i < imgs.length; ++i) {
          var img = imgs[i]
          var path = img.image_path
          var idx = path.lastIndexOf('/')
          if (idx !== -1) {
            var e = this.imgList.findIndex((ele) => {
              return ele.id === img.id
            })
            if (e === -1) {
              var fname = path.substr(idx + 1)
              var url = this.getImgURL(path)
              var item = {
                id: img.id,
                image_path: img.image_path,
                name: fname,
                url: url
              }
              this.imgList.push(item)
            }
          }
        }
      }
    },
    removeImgList (imgs, img) {
      imgs.forEach((ele, idx) => {
        if (ele.id === img.id) {
          imgs.splice(idx, 1)
        }
      })
    },
    clearImgList (imgs) {
      imgs.splice(0, imgs.length)
    }
  },
  watch: {
    'formData.album_images' (imgs) {
      this.addImgList(imgs)
    },
    dataId (newId) {
      this.id = newId
    }
  }
}
</script>
